<div *ngIf="isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div>
  <div class="relative flex h-full gap-5 sm:h-[calc(100vh_-_150px)]">
    <div
      class="panel absolute z-10 hidden h-full w-[240px] max-w-full flex-none space-y-4 p-4 xl:relative xl:block xl:h-auto ltr:rounded-r-none ltr:xl:rounded-r-md rtl:rounded-l-none rtl:xl:rounded-l-md"
      [ngClass]="{ '!block': isShowTaskMenu }"
    >
      <div class="flex h-full flex-col pb-16">
        <div class="pb-5">
          <div class="flex items-center text-center">
            <div class="shrink-0">
              <icon-clipboard-text />
            </div>
            <h3 class="text-lg font-semibold ltr:ml-3 rtl:mr-3">
              {{ "billing.bill_list" | translate }}
            </h3>
          </div>
        </div>
        <div class="mb-5 h-px w-full border-b border-[#e0e6ed] dark:border-[#1b2e4b]"></div>
        <ng-scrollbar class="relative h-full grow ltr:pr-3.5 rtl:pl-3.5" appearance="compact">
          <div class="space-y-1">
            <button
              type="button"
              class="flex h-10 w-full items-center justify-between rounded-md p-2 font-medium hover:bg-white-dark/10 hover:text-primary dark:hover:bg-[#181F32] dark:hover:text-primary"
              [ngClass]="{
                'bg-gray-100 text-primary dark:bg-[#181F32] dark:text-primary': selectedTab === BillStatus.Paid,
              }"
              (click)="tabChanged(BillStatus.Paid)"
            >
              <div class="flex items-center">
                <icon-credit-card class="shrink-0" />
                <div class="ltr:ml-3 rtl:mr-3">
                  {{ "billing.paid" | translate }}
                </div>
              </div>
            </button>
            <button
              type="button"
              class="flex h-10 w-full items-center justify-between rounded-md p-2 font-medium hover:bg-white-dark/10 hover:text-danger dark:hover:bg-[#181F32] dark:hover:text-danger"
              [ngClass]="{
                'bg-gray-100 text-danger dark:text-danger': selectedTab === BillStatus.Unpaid,
              }"
              (click)="tabChanged(BillStatus.Unpaid)"
            >
              <div class="flex items-center">
                <icon-credit-card class="shrink-0" />
                <div class="ltr:ml-3 rtl:mr-3">
                  {{ "billing.unpaid" | translate }}
                </div>
              </div>
            </button>
          </div>
        </ng-scrollbar>
        <div class="absolute bottom-0 w-full p-4 ltr:left-0 rtl:right-0"></div>
      </div>
    </div>
    <div class="overlay absolute z-[5] hidden h-full w-full rounded-md bg-black/60" [ngClass]="{ '!block xl:!hidden': isShowTaskMenu }" (click)="isShowTaskMenu = !isShowTaskMenu"></div>
    <div class="panel h-full flex-1 overflow-auto p-0">
      <div class="flex h-full flex-col px-5">
        <div class="flex w-full flex-col gap-4 p-4 pb-0 px-0 sm:flex-row sm:items-center">
          <div class="mb-4.5 w-full flex flex-col gap-5 md:flex-row md:items-center">
            <button type="button" class="block hover:text-primary xl:hidden ltr:mr-3 rtl:ml-3" (click)="isShowTaskMenu = !isShowTaskMenu">
              <icon-menu />
            </button>
            <app-search-input (searchChanged)="searchTasks($event)"></app-search-input>
            <div class="ml-auto flex gap-4">
              <div hlMenu class="dropdown">
                <button hlMenuButton type="button" class="flex items-center rounded-md border border-[#e0e6ed] px-4 py-2 text-sm font-semibold dark:border-[#253b5c] dark:bg-[#1b2e4b] dark:text-white-dark">
                  <span class="ltr:mr-1 rtl:ml-1">{{ "table_columns" | translate }}</span>
                  <icon-caret-down class="h-5 w-5" />
                </button>
                <ul *hlMenuItems @toggleAnimation class="w-max ltr:left-0 rtl:right-0">
                  <ng-container *ngFor="let col of cols; index as i">
                    <li>
                      <div class="flex items-center px-4 py-1">
                        <label [for]="'chk-' + i" class="mb-0 cursor-pointer">
                          <input type="checkbox" [id]="'chk-' + i" class="form-checkbox" [ngModel]="!col.hide" (ngModelChange)="col.hide = $event" (change)="updateColumn(col)" />
                          <span class="ltr:ml-2 rtl:mr-2">{{ col.title }}</span>
                        </label>
                      </div>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ng-datatable [rows]="filteredTasks" [columns]="cols" [sortable]="true" [search]="search" skin="whitespace-nowrap bh-table-hover">
          <ng-template slot="createdDate" let-value="data">
            <div class="flex items-center font-semibold">
              {{ value.createdDate | date: "dd.MM.yyyy" }}
            </div>
          </ng-template>
          <ng-template slot="startDate" let-value="data">
            <div class="flex items-center font-semibold">
              {{ value.startDate | date: "dd.MM.yyyy" }}
            </div>
          </ng-template>
          <ng-template slot="endDate" let-value="data">
            <div class="flex items-center font-semibold">
              {{ value.endDate | date: "dd.MM.yyyy" }}
            </div>
          </ng-template>
          <ng-template slot="price" let-value="data">
            <div class="flex items-center font-semibold">{{ value.price }} $</div>
          </ng-template>
          <ng-template slot="deliveryStatus" let-value="data">
            <div hlMenu class="dropdown inline-flex">
              <span class="badge" [ngClass]="getDeliveryStatusClass(value.isSent)">
                <span *ngIf="value.isSent">{{ "billing.sent" | translate }}</span>
                <span *ngIf="!value.isSent">{{ "billing.not_sent" | translate }}</span>
              </span>
            </div>
          </ng-template>
          <ng-template slot="status" let-value="data">
            <span class="badge" [ngClass]="[value.status === 0 ? 'badge-outline-success' : 'badge-outline-danger']">
              {{ value.status == 0 ? "Paid" : "Unpaid" }}
            </span>
          </ng-template>
          <ng-template slot="actions" let-value="data">
            <div class="flex w-max items-center justify-between">
              <div hlMenu class="dropdown">
                <a hlMenuButton href="javascript:;">
                  <icon-horizontal-dots class="rotate-90 opacity-70" />
                </a>
                <div #dropdownPlaceholder *hlMenuItems>
                  <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                    <li>
                      <a *hlMenuItem="let menuItem" [routerLink]="['/bill-preview', value.contractId, value.id]">
                        <icon-eye class="shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "bills.preview" | translate }}
                      </a>
                    </li>
                    <li>
                      <a *hlMenuItem="let menuItem" [routerLink]="['/contracts', value.contractId]">
                        <icon-eye class="shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "view_contract" | translate }}
                      </a>
                    </li>
                    <li *ngIf="value.status === 1">
                      <a href="javascript:;" *hlMenuItem="let menuItem" (click)="updateStatus(value.id, 0)">
                        <icon-dollar-sign-circle class="shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "bills.set_paid" | translate }}
                      </a>
                    </li>
                    <li *ngIf="value.status === 0">
                      <a href="javascript:;" *hlMenuItem="let menuItem" (click)="updateStatus(value.id, 1)">
                        <icon-dollar-sign-circle class="shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "bills.set_unpaid" | translate }}
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openDeleteModal(value.id)">
                        <icon-trash class="shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "delete_quick_label" | translate }}
                      </a>
                    </li>
                  </app-message-portal>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-datatable>
      </div>
    </div>
  </div>

  <ng-template #deleteConfirmationTemplate>
    <div class="flex flex-col p-4">
      <div class="!pb-5 text-xl">{{ "billing.delete_title" | translate }}</div>
      <div>
        <span>{{ "billing.delete_info" | translate }} </span>
      </div>
      <div class="mt-4 flex justify-end">
        <button class="rounded-lg bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300" (click)="closeDeleteModal()">{{ "cancel" | translate }}</button>
        <button class="btn btn-danger ml-3" [disabled]="isLoadingDelete" (click)="handleDelete()">
          <ng-container *ngIf="isLoadingDelete; else alternateTranslation">
            <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
            {{ "deleting" | translate }}
          </ng-container>
          <ng-template #alternateTranslation>
            {{ "delete_quick_label" | translate }}
          </ng-template>
        </button>
      </div>
    </div>
  </ng-template>
</div>
